import type { Theme } from '@mui/material';
import { px2rem } from '../../../utils/px2rem';

export const BASE_FONT_SIZE_NUMBER = 16;
export const BASE_FONT_SIZE = `${BASE_FONT_SIZE_NUMBER}px`;

const rem = (px: number) => px2rem(px, BASE_FONT_SIZE_NUMBER);

export const fontWeights = {
  light: 300,
  regular: 400,
  // medium: 500, this is not available in Lato V1
  bold: 700,
};

export const fontFamilyLato = [
  'Lato',
  '-apple-system',
  'BlinkMacSystemFont',
  'sans-serif',
];

export const fontFamilyLatoString = fontFamilyLato.join(',');

export const getTypography = (theme: Theme) => ({
  h1: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(30),
    fontWeight: fontWeights.bold,
    letterSpacing: `-${rem(0.4)}`,
    lineHeight: rem(24),
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(32),
      lineHeight: rem(40),
    },
  },
  h2: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(27),
    fontWeight: fontWeights.bold,
    letterSpacing: 0,
    lineHeight: rem(35),
    marginBottom: rem(16),
    [theme.breakpoints.up('sm')]: {
      fontSize: rem(28),
      lineHeight: rem(38),
    },
  },
  h3: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(24),
    fontWeight: fontWeights.bold,
    letterSpacing: 0,
    lineHeight: rem(35),
    marginBottom: rem(8),
  },
  h4: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.bold,
    fontSize: rem(20),
    lineHeight: rem(28),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  h5: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.bold,
    fontSize: rem(16),
    lineHeight: rem(24),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  h6: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.bold,
    fontSize: rem(14),
    lineHeight: rem(20),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  body1: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.regular,
    fontSize: rem(16),
    lineHeight: rem(24),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  body2: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.regular,
    fontSize: rem(14),
    lineHeight: rem(20),
    letterSpacing: rem(0.25),
    marginBottom: rem(8),
  },
  subtitle1: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(16),
    fontWeight: fontWeights.bold,
    lineHeight: rem(24),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  subtitle2: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(14),
    fontWeight: fontWeights.bold,
    lineHeight: rem(20),
    letterSpacing: 0,
    marginBottom: rem(8),
  },
  button: {
    fontFamily: fontFamilyLatoString,
    fontWeight: fontWeights.bold,
    fontSize: rem(14),
    lineHeight: rem(22),
    letterSpacing: rem(0.25),
    marginBottom: rem(8),
  },
  overline: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(12),
    fontWeight: fontWeights.bold,
    lineHeight: rem(22),
    letterSpacing: rem(0.25),
    marginBottom: rem(8),
  },
  caption: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(12),
    fontWeight: fontWeights.regular,
    lineHeight: rem(20),
    letterSpacing: rem(0.25),
    marginBottom: rem(8),
  },
});
